<template>
  <v-card class="perso_card" width="100%">
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pt-0">
          <h2 class="my-4 text-h5">{{ linksItem.title }}</h2>
          <p
            class="my-0 pa-1 text-caption"
            style="
              position: absolute;
              text-align: right;
              padding: 8px;
              right: 4px;
              top: 2px;
            "
          >
            {{ dateStr(linksItem.date) }}
          </p>
          <p class="text-body-1">
            {{ linksItem.content }}
          </p>
          <a :href="linksItem.link" target="_blank" class="text-body-1">
            {{ linksItem.link }}
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style scoped>
.perso_card {
  border: 1px solid rgba(202, 5, 56, 0.4);
}
</style>

<script>
export default {
  data() {
    return {};
  },
  props: {
    linksItem: Object,
  },
  methods: {
    dateStr(date) {
      if (date) {
        const newdate = new Date(date);
        return newdate.toLocaleDateString("fr-FR");
      } else {
        return "";
      }
    },
  },
};
</script>
